import * as Types from '../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DualResumesEnabledQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DualResumesEnabledQuery = { __typename?: 'Query', jobSeekerProfileDualResumesEnabled?: { __typename?: 'JobSeekerProfileDualResumesEnabledPayload', enabled: boolean, allResumesEnabled: boolean } | null };


export const DualResumesEnabledDocument = gql`
    query DualResumesEnabled {
  jobSeekerProfileDualResumesEnabled {
    enabled
    allResumesEnabled
  }
}
    `;

/**
 * __useDualResumesEnabledQuery__
 *
 * To run a query within a React component, call `useDualResumesEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useDualResumesEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDualResumesEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useDualResumesEnabledQuery(baseOptions?: Apollo.QueryHookOptions<DualResumesEnabledQuery, DualResumesEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DualResumesEnabledQuery, DualResumesEnabledQueryVariables>(DualResumesEnabledDocument, options);
      }
export function useDualResumesEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DualResumesEnabledQuery, DualResumesEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DualResumesEnabledQuery, DualResumesEnabledQueryVariables>(DualResumesEnabledDocument, options);
        }
export function useDualResumesEnabledSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DualResumesEnabledQuery, DualResumesEnabledQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DualResumesEnabledQuery, DualResumesEnabledQueryVariables>(DualResumesEnabledDocument, options);
        }
export type DualResumesEnabledQueryHookResult = ReturnType<typeof useDualResumesEnabledQuery>;
export type DualResumesEnabledLazyQueryHookResult = ReturnType<typeof useDualResumesEnabledLazyQuery>;
export type DualResumesEnabledSuspenseQueryHookResult = ReturnType<typeof useDualResumesEnabledSuspenseQuery>;
export type DualResumesEnabledQueryResult = Apollo.QueryResult<DualResumesEnabledQuery, DualResumesEnabledQueryVariables>;